import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useCreateDemoAccount } from "@/hooks/use-create-demo-account";

// ADV-1276 integration point: when that hook lands and `available` becomes
// true (or the hook exports a real mutation), the button auto-enables.
export function RunFullPipelineButton({ datasetId }: { datasetId?: string }) {
  const hook = useCreateDemoAccount({ mode: "full" });

  if (!hook.available) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span tabIndex={0}>
              <Button
                variant="outline"
                size="sm"
                disabled
                aria-disabled="true"
                className="pointer-events-none"
              >
                <Play className="mr-1.5 h-3.5 w-3.5" />
                Run full-pipeline E2E test
              </Button>
            </span>
          </TooltipTrigger>
          <TooltipContent>
            Available after demo-account provisioning ships (ADV-1276)
            {datasetId ? ` — dataset: ${datasetId}` : ""}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  // ADV-1276: wire real mutation here when hook.available becomes true.
  return (
    <Button variant="outline" size="sm">
      <Play className="mr-1.5 h-3.5 w-3.5" />
      Run full-pipeline E2E test
    </Button>
  );
}
